export default __webpack_public_path__ + "static/media/contactsGreen.8f2a6a03.svg";